(() => {
  const init = () => {
    document.querySelectorAll('[data-kaw-tabs]').forEach((tabs) => {
      if (tabs.dataset.kawReady) return;
      tabs.dataset.kawReady = 'true';

      const buttons = Array.from(tabs.querySelectorAll('[data-kaw-tab]'));
      const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));

      const select = (index, focus) => {
        buttons.forEach((b, i) => {
          const active = i === index;
          b.classList.toggle('kaw-product-details__tab--active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
          b.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) buttons[index].focus();
      };

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index, false));

        button.addEventListener('keydown', (event) => {
          let target = null;
          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              target = (index + 1) % buttons.length;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              target = (index - 1 + buttons.length) % buttons.length;
              break;
            case 'Home':
              target = 0;
              break;
            case 'End':
              target = buttons.length - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          select(target, true);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
